import { useLang } from "@/lib/i18n";
import { useNavigate } from "react-router-dom";

// Optional enHref/frHref let a page pair two equivalent EN/FR URLs: clicking a language then
// navigates to its counterpart. Without them the toggle behaves exactly as before (locale only).
export default function LanguageToggle({ className = "", enHref, frHref }) {
  const { lang, setLang } = useLang();
  const navigate = useNavigate();

  const pick = (l, href) => {
    setLang(l);
    if (href) navigate(href);
  };

  return (
    <div
      className={`relative flex items-center rounded-full border border-white/15 p-0.5 text-xs font-bold ${className}`}
      data-testid="language-toggle"
    >
      <span
        className="pointer-events-none absolute top-0.5 bottom-0.5 w-[calc(50%-2px)] rounded-full bg-aqua transition-transform duration-300 ease-out"
        style={{ transform: lang === "fr" ? "translateX(100%)" : "translateX(0%)" }}
        aria-hidden
      />
      <button
        type="button"
        onClick={() => pick("en", enHref)}
        className={`relative z-10 w-9 py-1 transition-colors duration-300 ${lang === "en" ? "text-abyss" : "text-white/60 hover:text-white"}`}
        data-testid="lang-en"
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => pick("fr", frHref)}
        className={`relative z-10 w-9 py-1 transition-colors duration-300 ${lang === "fr" ? "text-abyss" : "text-white/60 hover:text-white"}`}
        data-testid="lang-fr"
      >
        FR
      </button>
    </div>
  );
}
